import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from '@axiom/ui';
import type { AfcSubmission } from '@axiom/validation';

import { OpportunityApi } from '../../api/opportunity-api';
import { SubmissionApi } from '../../api/submission-api';

export const EngagementsRemoveContactModal = ({
  contactId,
  name,
  opportunityId,
  submissionId,
  onClose,
}: {
  contactId: NonNullable<AfcSubmission['contacts']>[number]['id'];
  name: NonNullable<AfcSubmission['contacts']>[0]['fullName'];
  opportunityId: AfcSubmission['id'];
  submissionId: AfcSubmission['submissionId'];
  onClose: () => void;
}) => {
  return (
    <Modal size="confirm" name="DELETE_CONTACT_OPP_MODAL">
      <ModalHeader
        onClose={() => {
          onClose();
        }}
        name="DELETE_CONTACT_MODAL_HEADER"
      >
        Remove Access
      </ModalHeader>
      <ModalSection name="DELETE_CONTACT_CONTENT">
        Please confirm that you want to remove {name} from having access to this
        engagement.
      </ModalSection>
      <ModalFooter>
        <Button
          name="DELETE_CONTACT_CANCEL"
          variation="outline"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          name="DELETE_CONTACT_SUBMIT"
          onClick={async () => {
            await OpportunityApi.deleteContactOpp(opportunityId, contactId);
            await SubmissionApi.refreshSubmissionDetails(submissionId);
            onClose();
          }}
        >
          Yes, Remove
        </Button>
      </ModalFooter>
    </Modal>
  );
};
